import React from 'react';
import MiCompAPI from '../../../util/api';
import { Form, Input, Button, Row, Col } from 'antd';
import InputMask from "react-input-mask";
class UserForm extends React.Component {
    constructor(props) {
      super(props)
      this.state = {
        isValueExists: false,
      }
      this.api = new MiCompAPI(null);
    }
    handleSubmit = (e) => {
      e.preventDefault();
      this.props.form.validateFields((err, values) => {
        if (!err&&!this.state.isValueExists) {
          this.props.submitHandler({...values,id:0, invitation_Id: this.props.data.data.id,
            userRoleID: this.props.data.data.role_Id});
        }
      });
    }
    Cancel() {
      sessionStorage.clear();
      window.location.pathname = "";
    }
    componentDidMount() {
      if (this.props.data)
      this.props.form.setFieldsValue({
        first_Name: this.props.data.data.first_Name,
        middle_Name: this.props.data.data.middle_Name,
        last_Name: this.props.data.data.last_Name,
        phoneNo: this.props.data.data.phoneNo,
        email: this.props.data.data.email,
        invitation_Id: this.props.data.data.invitation_Id,
        userRoleID: this.props.data.data.userRoleID
      });
    }
    handleChange = (e) => {
      if (e.target.value && e.target.value.length > 4) {
        this.api.invoke("IsValueExists/USERS/" + e.target.value + "/USERNAME", "get", (data, success) => {
          if (success) {
            this.setState({ isValueExists: data.data });
          }
        });
      }
    }
    render() {
      const { getFieldDecorator, getFieldValue } = this.props.form;
      return (
        <Form onSubmit={this.handleSubmit} layout="vertical" autoComplete="none" hideRequiredMark>
          <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">First Name</legend>
                  {getFieldDecorator('first_Name', {
                    rules: [{ required: true, message: 'Please enter the First Name' },
                    {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "It allows only Alphabets,No whitespace at the beginning and end"
                    }],
                  })(<Input type="text"  autoComplete={"nope"}  className="mi_input" placeholder="Enter First Name *" />)}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Middle Name</legend>
                  {getFieldDecorator('middle_Name', {
                    rules: [{ required:
                      false, message: 'Please enter Middle Name' },
                      {
                        pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                        message: "It allows only Alphabets,No whitespace at the beginning and end"
                      }],
                  })(<Input type="text" autoComplete={"nope"}  className="mi_input" placeholder="Enter Middle Name"/>)}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>
          <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Last Name</legend>
                  {getFieldDecorator('last_Name', {
                    rules: [{ required: true, message: 'Please enter Last Name' }
                    ,
                    {
                      pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z\s]+$/,
                      message: "It allows only Alphabets,No whitespace at the beginning and end"
                    }],
                  })(<Input type="text" autoComplete={"nope"}  className="mi_input" placeholder="Enter Last Name *" />)}
                </fieldset>
              </Form.Item>
            </Col>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Phone Number</legend>
                  {getFieldDecorator('phoneNo', {
                    rules: [{ required: true, message: 'Please enter Phone No' },
                    { pattern: /^((\+0?1\s)?)\(?\d{3}\)?[\s.\s]\d{3}[\s.-]\d{4}$/,
                    message: 'phone number is invalid'}],
                  })(<InputMask mask="+1 (999) 999-9999" autoComplete={"nope"}  className="ant-input mi_input" placeholder="Enter Phone Number *" />)}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>
          <Row span={24}>
            <Col md={12} sm={24}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Email</legend>
                  {getFieldDecorator('email', {
                    rules: [{
                      type: 'email', message: 'The input is not valid E-mail!.',
                    }, { required: true, message: 'Please enter the primary contact\'s email id' },
                    { whitespace: true, message: "Email is invalid." },
                    {
                      pattern: /^([a-zA-Z0-9\s.]+)@([a-zA-Z0-9]+)\.([a-zA-Z]{2,5})$/,
                      message: 'Email is invalid.'}],
                  })(<Input type="email" disabled autoComplete={"nope"}  className="mi_input" placeholder="Enter Email *" />)}
                </fieldset>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">User Name</legend>
                  {getFieldDecorator('userName', {
                    rules: [{ required: true, message: 'Please enter User Name' },
                    { min: 5, message: 'Username must be 5 characters minimum.' },
                    {pattern:"It allows only Alphanumerics,No whitespace at the beginning and end"}],
                  })(<Input type="text" autoComplete={"nope"}  onChange={this.handleChange.bind(this)} className="mi_input" placeholder="Enter User Name *" />)}
                </fieldset>
              </Form.Item>
              {this.state.isValueExists ? <p style={{ color: "red", marginTop: '5px', marginLeft: '12px' }}>User Name already exists</p> : ""}
            </Col>
          </Row>
          <Row span={24}>
            <Col span={12}>
              <Form.Item>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Password</legend>
                  {getFieldDecorator('pass', {
                    rules: [{ required: true, message: 'Please enter a password' },
                    {
                      pattern: /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/,
                      message: "Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character!"
                    }],
                  })(<Input.Password type="password" autoComplete={"nope"}  className="mi_input" placeholder="Enter Password *" />)}
                </fieldset>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item dependencies={['pass']}>
                <fieldset className="mi_input_pop">
                  <legend className="legend-font">Confirm Password</legend>
                  {getFieldDecorator('password', {
                    rules: [{ required: true, message: 'Please confirm your password!' },
                    {
                      validator(rule, value) {
                        if (!value || getFieldValue('pass') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject('passwords that you entered do not match!');
                      }
                    }
                    ],
                  })(<Input.Password type="password" autoComplete={"nope"}  className="mi_input" placeholder="Enter Confirm Password *" />)}
                </fieldset>
              </Form.Item>
            </Col>
          </Row>
          <Row span={24} style={{ marginTop: '15px' }}>
            <Col span={12}>
              <Form.Item>
                <Button className="submit-button" style={{ float: 'right' }} onClick={() => this.Cancel()}>
                  Cancel
                  </Button>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item>
                <Button className="submit-button" htmlType="submit" type="primary">
                  Submit
                              </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      );
    }
  }
  export default UserForm;